import React from 'react'

function Footer() {
    return (
        <div>
            <footer class="text-gray-600 body-font">
                <div class="container px-5 py-8 mx-auto flex items-center sm:flex-row flex-col">
                    <a class="flex title-font font-medium items-center md:justify-start justify-center text-gray-900">
                        <img src="images/logo.svg" className="h-24 -m-6"></img>
                        <span class="text-xl text-purple-800">Photo Fit</span> <span className="ml-2 text-xl text-gray-400"> by </span> <span className="ml-2 px-2 py-1 text-xs text-white bg-twitter rounded-md"><a target="_" href="https://twitter.com/prash2018">@prash2018</a></span>
                    </a>

                    <span class="flex flex-col items-center sm:flex sm:flex-row sm:ml-auto sm:mt-0 mt-4 justify-center sm:justify-start">
                        <a href="https://buymeacoffee.com/prashant2018" target="_"><img src="images/coffee.svg" className="h-11"></img></a>
                        <p class="text-sm text-gray-500 sm:ml-4 sm:pl-4 sm:border-gray-200 sm:py-2 sm:mt-0 mt-4">© 2021 Photo Fit —
                            <a href="/privacy.html" class="text-gray-600 ml-1" rel="noopener noreferrer" target="_blank">Privacy</a>
                        </p>
                    </span>
                </div>
            </footer>
        </div>
    )
}

export default Footer
